/*
 * @Author: 吴文洁
 * @Date: 2019-08-30 10:04:15
 * @LastEditors: fangpu
 * @LastEditTime: 2023-09-26 17:25:13
 * @Description: 
 */
import getUrlParam from '../utils/getUrlParam';
/**
 * 拼接跳转的路由path
 * @param path   要跳转的路由地址
 * @param previewType  跳转页面的预览类型
 */
export default function dealRouterPath(path: string, previewType: string): string {
  const v: string = getUrlParam('v') as string;
  const id: string = getUrlParam("id") as string;
  const vn: string = getUrlParam('vn') as string;
  const aid: string = getUrlParam('aid') as string;
  const uid: string = getUrlParam('uid') as string;
  const type: string = getUrlParam("type") as string;
  const instId: string = getUrlParam('instId') as string;
  const adminId: string = getUrlParam('adminId') as string;
  const promoterId: string = getUrlParam('promoterId') as string;
  const referralId: string = getUrlParam('referralId') as string;
  const broadcastId: string = getUrlParam('broadcastId') as string;
  const referralAppId: string = getUrlParam("referralAppId") as string;
  const state: string = getUrlParam("state") as string;
  const orgId: string = getUrlParam("orgId") as string;
  const xcxType: string = getUrlParam("xcxType") as string;
  const enterType: string = getUrlParam('enterType') as string;
  const token: string = getUrlParam('token') as string;

  const url = `${path}?source=${type}&xcxType=${xcxType}&type=${previewType}&id=${id}${broadcastId ? `&broadcastId=${broadcastId}` : ''}${
    instId ? `&instId=${instId}` : ''
  }${adminId ? `&adminId=${adminId}` : ''}${promoterId ? `&promoterId=${promoterId}` : ''}${referralId ? `&referralId=${referralId}` : ''}${
    referralAppId ? `&referralAppId=${referralAppId}` : ''
  }${state ? `&state=${state}` : ''}${orgId ? `&orgId=${orgId}` : ''}${aid ? `&aid=${aid}` : ''}${uid ? `&uid=${uid}` : ''}${token ? `&token=${token}` : ''}${
    vn ? `&vn=${vn}` : ''
  }${v ? `&v=${v}` : ''}${enterType ? `&enterType=${enterType}` : ''}`;

  return url;
}